<template>
    <section class="awaiting-bonus-sec">
        <div class="pending-bonus-transfer-sec">
            <div class="awaitning-back-btn">
                <a href="/"><i class="fa-solid fa-angle-left"></i></a>
                <span>Responsible Gambling</span>
            </div>
        </div>
    </section>

    <section class="responsible-gambling-wrapper">
        <div class="v-card__text text-justify">
            <div class="gambling-intro mt-5">
                <h4>Policy</h4>
                <p>
                    FairPlay is committed to giving its users an enjoyable gambling experience, whilst recognising the adverse effects it might have on some individuals. To ensure that you have a safe and controlled play, we encourage responsible
                    gambling and have the necessary measures to keep a check on the same.
                </p>
                <p>
                    Click here for more information about how to gamble responsibly, in accordance with GambleAware
                </p>
                <h4>
                    1. Gambling Self-Assessment and Help Organisations
                </h4>
                <p>
                    For assistance in identifying whether to modify or seek help for your gambling patterns, we suggest you take the NODS Self-Assessment in order to impartially assess and better understand your current levels of play.
                </p>
                <p>
                    If you or someone you know has a gambling problem we advise you consider reaching out to the below recognised organisations:
                </p>
            </div>
            <div class="general gambling-intro mt-3">
                <h4>GamCare</h4>
                <p>
                    Website:
                    <a :href="location?.origin" target="_blank"> {{$siteSettings?.data.domain_name}} </a>
                </p>
                <p>
                    UK National Helpline:

                    <a :href="location?.origin" target="_blank"> {{$siteSettings?.data.domain_name}} </a>
                </p>
                <h4>Gamblers Anonymous</h4>
                <p>
                    Website:
                    <a :href="location?.origin" target="_blank"> {{$siteSettings?.data.domain_name}} </a>
                </p>
                <h4>GambleAware</h4>
                <p>
                    Website:
                    <a :href="location?.origin" target="_blank"> {{$siteSettings?.data.domain_name}} </a>
                </p>
                <p>
                    UK National Helpline:
                    <a href="https://wa.link/fairplayapi-12" target="_blank" rel="noreferrer noopener">Get in touch</a>
                </p>
                <h4>National Problem Gambling Clinic</h4>
                <p>
                    Website:
                    <a :href="location?.origin" target="_blank"> {{$siteSettings?.data.domain_name}} </a>
                </p>
                <p>
                    UK National Helpline:
                    <a href="https://wa.link/fairplayapi-12" target="_blank" rel="noreferrer noopener">Get in touch</a>
                </p>
                <h4>GamCare</h4>
                <p>
                    Website:
                    <a :href="location?.origin" target="_blank"> {{$siteSettings?.data.domain_name}} </a>
                </p>
                <p>
                    UK National Helpline:
                    <a href="https://wa.link/fairplayapi-12" target="_blank" rel="noreferrer noopener">Get in touch</a>
                </p>
                <h4>2. Identity Checks</h4>
                <p>
                    We take stringent steps to ensure that only people of legal age participate and engage on FairPlay. These checks include requesting all customers to submit a copy of a photographic identification documents (such as a driver's
                    licence, a passport or a government issued identity card), in order to verify both age and identity.
                </p>
                <p>
                    The legal age for gambling online varies from country to country and so we advise that you check the rules of your jurisdiction before you begin to play.
                </p>
                <p>
                    An Electronic Age Verification Check will be performed upon registration of an account with FairPlay. For further details, please refer to our Age Verification Policy.
                </p>
                <p>
                    Any personal details we request from you are purely to verify your identity – this is a legal requirement for your protection and ours. If you have any questions about our identity checks, please feel free to contact Customer
                    Services at any time.
                </p>
                <h4>3. Staying in Control</h4>
                <p>
                    FairPlay encourages the Club members to actively participate in the management of their gambling account and thus offers a whole range of responsible gambling features:
                </p>
                <h4>3.1 Set Deposit Limits</h4>
                <p>
                    Take financial control of your gambling account with the ability to set your preferred deposit limits.
                </p>
                <p>
                    Deposit limits will apply across all accounts you hold with the respective brands offered by FairPlay Limited (Hippodrome, Spin Casino, Bingo on the Box and Dream Bingo).
                </p>
                <p>
                    Deposit limits may be set for the following periods:
                </p>
                <ul>
                    <li>Daily</li>
                    <li>Weekly (Monday to Sunday)</li>
                    <li>Monthly (calendar month)</li>
                </ul>
                <p>
                    At your request, deposit limits are subject to being reduced, increased or removed altogether. An increase or complete removal of deposit limits will take effect after a 24 hour buffer, whilst a decrease of deposit limits will
                    be effective immediately.
                </p>
                <p>
                    If you would like to set or adjust a deposit limit, please login to your account and go to “Set Limits”.
                </p>
                <p>
                    Alternatively, you can contact Client Services for assistance with the same.
                </p>
                <h4>3.2 Take a Break</h4>
                <p>
                    At FairPlay we understand that a Club member’s personal/ financial circumstances are subject to change and that there will be times when it is only right to take a break from gambling. We offer the “Take A Break” in the
                    following periods:
                </p>
                <ul>
                    <li>24 hours</li>
                    <li>48 hours</li>
                    <li>1 week</li>
                    <li>2 weeks</li>
                    <li>3 weeks</li>
                    <li>4 weeks</li>
                    <li>6 weeks</li>
                </ul>
                <p>
                    Upon receiving your request, Team FairPlay will temporarily suspend all accounts you hold with brands managed by FairPlay Group until your break period has been fulfilled.
                </p>
                <p>
                    <strong>NOTE:</strong> Once the “Take A Break” period expires, your account will automatically be re-activated unless an extension is requested and you will once again have access to all the platforms provided by FairPlay Group.
                </p>
                <h4>3.3 Activity Statement</h4>
                <p>
                    Information regarding every single of your gambling activities on FairPlay can be viewed for up to 30 days. The information includes the start date and time of your gambling session as well as its duration.
                </p>
                <p>
                    Further information regarding your activity on FairPlay can also be viewed for a period of 90 days. The information includes details about your account balance, gambling history (including bet amounts, winnings and losses),
                    deposits, withdrawals and other related transactions.
                </p>
                <h4>3.4 Session Reminders</h4>
                <p>
                    FairPlay allows you to set a “Session Reminder” so you can keep track of the time you spend gambling.
                </p>
                <p>
                    Upon expiry of the time period selected, an automated message reminding you of how long you've been playing will appear on the screen and requires you to select one of the following three options:
                </p>
                <ul>
                    <li>Continue; or</li>
                    <li>Exit (end the game); or</li>
                    <li>View Account History</li>
                </ul>
                <p>
                    <strong>NOTE:</strong> The Session Reminder set within the My Account feature does not apply to Live Casino games. You can set a separate Session Reminder within our Live Casino games offering via the ‘Game Session Settings’
                    feature under Settings.
                </p>
                <p>
                    If you would like to be notified about how long you've been playing, please login in and then set a Session Reminder. Alternatively, you can contact Client Services for personal assistance.
                </p>
                <h4>3.5 Account Closure</h4>
                <p>
                    If you feel like taking some time away from gambling, or it just doesn’t seem entertaining anymore, you can simply close your account. You can re-open the account at any time by contacting Client Services. If you would prefer to
                    just take some time off instead, please refer to our “Take a Break” option, which will restrict access to your account from 24 hours up to 6 weeks.
                </p>
                <h4>3.6 Stop Gambling - Self-Exclusion</h4>
                <p>
                    Should you consider that gambling has become a liability, you can choose to “Self Exclude” from future participation on all platforms offered by FairPlay Group.
                </p>
                <p>Self-Exclusion is valid for:</p>
                <ul>
                    <li>6 months</li>
                    <li>1 year</li>
                    <li>2 years</li>
                    <li>3 years</li>
                    <li>4 years</li>
                    <li>5 years</li>
                </ul>
                <p>
                    Upon receiving your Self-Exclusion request, Team FairPlay will take the necessary measures to restrict your access across all brands managed by FairPlay Group and will reach out to you regarding your account balance if any,
                    outstanding wagers and/or unused bonus money. contact you with a view to returning any remaining funds held in account balances cancelling any outstanding wagers and less any unused bonus money.
                </p>
                <p>
                    As an additional preventative measure, FairPlay recommends you to consider activating the same safeguard with other gambling operators where you might hold an account.
                </p>
                <p>
                    <strong>NOTE:</strong> Upon the Exclusion period expiring, your account will not automatically be re-activated. The account may only be considered for re-activation by FairPlay at your own request (contact must be by telephone)
                    and will only come into effect after a further 24 hour buffer has been fulfilled. Please note your return is not guaranteed and is subject to internal checks.
                </p>
                <p>
                    If you feel the need to stop gambling, you can set a self-exclusion period by logging in and then clicking here. Alternatively, you can contact Customer Service for personal assistance.
                </p>
                <p>
                    If you are considering self-exclusion, you might want to register with FairPlay. FairPlay is a free service that helps you self-exclude from all online gambling activities licensed in Curaçao.
                </p>
                <p>
                    To know more and register on FairPlay, visit
                    <a hreflang="en" href="https://thefairplay.io" target="_blank" rel="noreferrer noopener">https://thefairplay.io</a>
                </p>
                <h4>3.7 Auto-Play Controls</h4>
                <p>
                    The Auto-Play (Expert) mode available on many of our Slot games has been enhanced to give you greater control of your game play. When using the Auto-Play mode you have the authority to set:
                </p>
                <ul>
                    <li>the stake / bet amount; and</li>
                    <li>the number of spins; and</li>
                    <li>a loss limit.</li>
                </ul>
                <p>Additionally you can also choose to set:</p>
                <ul>
                    <li>a single win amount.</li>
                </ul>
                <p>
                    The Auto-Play session will be interrupted and game play will stop the moment one or more of the above is triggered, thus ensuring you remain well within your set gambling limits.
                </p>
                <h4>3.8 Internal checks</h4>
                <p>
                    Team FairPlay conducts regular checks to ensure that our new and existing customers gamble only until a level that is harmless, safe and sustainable. FairPlay reserves the right to limit or suspend any account that flags as
                    unsafe. In such a case, the account balance will be returned to the user, subject to over viewing account activities.
                </p>
                <p>
                    While FairPlay endeavours to honour all bets placed by customers, in the event that it is established that your account/s should be suspended for responsible gambling reasons, FairPlay reserves the right to void any/ all active
                    bets as a safety measure.
                </p>
            </div>
        </div>

    </section>

</template>

<script> 
export default{
    name:'ResponsibleGambling',
    data() {
        return {
            location: null
        }
    },
    mounted() {
        this.location = window.location
    }
}
</script>